var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFourRangeStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2883 1.10996C14.4591 0.699319 15.0409 0.699318 15.2117 1.10996L18.5341 9.09817C18.6061 9.27129 18.769 9.38957 18.9558 9.40456L27.5798 10.0959C28.0231 10.1315 28.2029 10.6847 27.8651 10.9741L21.2946 16.6024C21.1522 16.7244 21.09 16.9158 21.1335 17.0982L23.1409 25.5137C23.2441 25.9463 22.7735 26.2882 22.3939 26.0564L15.0106 21.5467C14.8506 21.449 14.6494 21.449 14.4894 21.5467L7.10608 26.0564C6.72653 26.2882 6.2559 25.9463 6.3591 25.5137L8.3665 17.0982C8.41001 16.9158 8.34782 16.7244 8.20543 16.6024L1.63489 10.9741C1.29713 10.6847 1.47689 10.1315 1.92022 10.0959L10.5442 9.40456C10.731 9.38957 10.8939 9.27129 10.9659 9.09817L14.2883 1.10996Z",
    fill: "url(#paint0_linear_135_1454)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_135_1454",
    x1: 2.2125,
    y1: 14.75,
    x2: 27.2875,
    y2: 14.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6399,
    stopColor: "#FDB022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#C8D0DD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFourRangeStar);
export default __webpack_public_path__ + "static/media/four-range-star.52f1b9b39fb13e93c96e2b48d72d782d.svg";
export { ForwardRef as ReactComponent };